import { render, staticRenderFns } from "./AddImageGroupModal.vue?vue&type=template&id=fda1a142"
import script from "./AddImageGroupModal.vue?vue&type=script&lang=js"
export * from "./AddImageGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports